/* eslint-disable no-param-reassign */
import { errors } from '../../services/ruutsApi/errors'
import { PROGRAMS } from '../constants'

export function displayMessageFromError(errorMessage, error) {
  if (error instanceof errors.RuutsError) {
    const { unexpected } = error
    console.warn(error)
    return {
      unexpected,
      displayMessage: unexpected ? errorMessage : error.message,
    }
  }

  console.error(error)
  return {
    unexpected: false,
    displayMessage: errorMessage,
  }
}

// The map wins so known programs keep the codes support filters by (the API names RETERRA "ReTerra").
export const resolveProgramName = (farm, program) =>
  PROGRAMS[farm?.programId] ?? program?.name ?? 'N/A'

export function openSupportForm({ user, farm, program, title, reason, error }) {
  title = `${title} [${resolveProgramName(farm, program)} - ${farm?.Hub?.name} - ${farm?.name}]`
  let category = 'Otro'
  if (error && error.unexpected) {
    category = 'Error'
    reason = `${reason}\n\nError:\n`
    reason = `${reason}name:  ${error.name}\nmessage: ${error.message}\nat:${error.at}\ntext:${error.text}\nstack:${error.stack}`
  }

  window.open(
    `https://share.hsforms.com/1JLOc-3huQviHqJDhNl7XjQd7qz7?producto=RPD&hs_ticket_category=${category}&asunto=${title}&content=${encodeURIComponent(reason)}&email=${user.email}`,
    '_blank',
  )
}
